import Vue from 'vue'
import Router from 'vue-router'
import { Message } from 'element-ui'

Vue.use(Router)

// let moneyHistory=localStorage.getItem('routeName')||'钱包历史'
let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: '登录',
      component: () => import('@/views/login'),
      meta: {
        title: '登录',
      }
    },
    {
      path: '/index',
      redirect: '/products',
      name: '首页',
      component: () => import('@/views/index'),
      meta: {
        title: '首页',
      },
      children: [
        {
          path: '/promote',
          redirect: '/banner',
          name: '推广',
          component: () => import('@/views/promote'),
          meta: {
            title: '推广',
          },
          children: [
            {
              path: '/promoteSetting',
              name: '推广设置',
              component: () => import('@/views/promoteSetting'),
              meta: {
                title: '推广设置',
              },
            },
            // {
            //   path: '/promoteSetting',
            //   name: '推广设置',
            //   component: () => import('@/views/promoteSetting'),
            //   meta: {
            //     title: '推广设置',
            //   },
            // },
            {
              path: '/banner',
              name: '轮播图管理',
              component: () => import('@/views/banner'),
              meta: {
                title: '轮播图管理',
              },
            },
            {
              path: '/productRecommendation',
              name: '商品推荐管理',
              component: () => import('@/views/productRecommendation'),
              meta: {
                title: '轮播图管理',
              },
            },
            {
              path: '/PinterestAd',
              name: '瀑布流广告',
              component: () => import('@/views/PinterestAd'),
              meta: {
                title: '瀑布流广告',
              },
            },
            {
              path: '/groupRelation',
              name: '拼团广告',
              component: () => import('@/views/groupRelation'),
              meta: {
                title: '拼团广告',
              },
            },
            {
              path: '/nav',
              name: '首页ICON管理',
              component: () => import('@/views/nav'),
              meta: {
                title: '首页ICON管理',
              },
            },
            {
              path: '/systemMessage',
              name: '系统通知',
              component: () => import('@/views/systemMessage'),
              meta: {
                title: '系统通知',
              },
            },
            {
              path: '/activityBanner',
              name: '活动轮播',
              component: () => import('@/views/activityBanner'),
              meta: {
                title: '活动轮播',
              },
            },
            {
              path: '/officialActivity',
              name: '官方活动管理',
              component: () => import('@/views/officialActivity'),
              meta: {
                title: '官方活动管理',
              },
            },
            {
              path: '/promotionActivity',
              name: '促销活动管理',
              component: () => import('@/views/promotionActivity'),
              meta: {
                title: '促销活动管理',
              },
            },
            {
              path: '/theAuroraPushMessage',
              name: '消息推送',
              component: () => import('@/views/theAuroraPushMessage'),
              meta: {
                title: '消息推送',
              },
            },
            {
              path: '/productSearchRecommend',
              name: '热门搜索推荐',
              component: () => import('@/views/productSearchRecommend'),
              meta: {
                title: '热门搜索推荐',
              },
            },
            {
              path: '/activityList',
              name: '活动列表',
              component: () => import('@/views/activityList'),
              meta: {
                title: '活动列表',
              },
            },
            {
              path: '/Cropper',
              name: '图片裁截',
              component: () => import('@/views/Cropper'),
              meta: {
                title: '图片裁截',
              },
            },
            {
              path: '/advertising',
              name: '广告管理',
              component: () => import('@/views/advertising/index'),
              meta: {
                title: '广告管理',
              },
            },
            {
              path: '/festivaIActivity',
              name: '节日活动管理',
              component: () => import('@/views/festivaIActivity/index'),
              meta: {
                title: '节日活动管理',
              },
            },
            {
              path: '/homeModule',
              name: '首页模块图片设置',
              component: () => import('@/views/homeModule/index'),
              meta: {
                title: '首页模块图片设置',
              },
            },
          ]
        },
        //商品
        {
          path: '/commodity',
          redirect: '/supplier',
          name: '商品',
          component: () => import('@/views/products'),
          meta: {
            title: '商品',
          },
          children: [
            {
              path: '/supplier',
              name: '供应商',
              component: () => import('@/views/supplier/index'),
              meta: {
                title: '供应商',
              },
            },
            {
              path: '/theme',
              name: '主题',
              component: () => import('@/views/theme'),
              meta: {
                title: '主题',
              },
            },
            {
              path: '/products',
              name: '商品管理',
              component: () => import('@/views/products/products'),
              meta: {
                title: '商品管理',
              },
            },
            {
              path: '/addProducts',
              name: '添加商品',
              component: () => import('@/views/products/addProducts'),
              meta: {
                title: '添加商品',
              },
            },
            {
              path: '/categories',
              name: '类目管理',
              component: () => import('@/views/categories'),
              meta: {
                title: '类目管理',
              },
            },
            {
              path: '/freight',
              name: '运费管理',
              component: () => import('@/views/freight/index'),
              meta: {
                title: '运费管理',
              },
            },
            //指定地区
            {
              path: '/PlatformManager',
              name: '平台管理',
              component: () => import('@/views/freight/PlatformManager'),
              meta: {
                title: '平台管理',
              },
            },
          ]
        },
        //客户
        {
          path: '/client',
          redirect: '/customer',
          name: '客户',
          component: resolve => require(['@/views/customer'],resolve),
          // component: resolve => require(['@/views/customer/compile'],resolve),

          meta: {
            title: '客户',
          },
          children: [
            {
              path: '/customer',
              name: '客户管理',
              component: () => import('@/views/customer/customer'),
              meta: {
                title: '客户管理',
              },
            },
            {
              path: '/bankCardInfo',
              name: '客户管理银行卡信息',
              component: () => import('@/views/customer/bankCardInfo'),
              meta: {
                title: '客户管理银行卡信息',
              },
            },
            {
              path: '/topUp',
              name: '客户管理充值',
              component: () => import('@/views/customer/topUp'),
              meta: {
                title: '客户管理充值',
              },
            },
            {
              path: '/handbagTopUp',
              name: '包包充值',
              component: () => import('@/views/customer/handbagTopUp'),
              meta: {
                title: '包包充值',
              },
            },{
              path: '/handYjTopUp',
              name: '云吉充值',
              component: () => import('@/views/customer/handYjTopUp'),
              meta: {
                title: '云吉充值',
              },
            },
            {
              path: '/handYjOverseasTopUp',
              name: '云吉海外充值',
              component: () => import('@/views/customer/handYjOverseasTopUp'),
              meta: {
                title: '云吉海外充值',
              },
            },
            {
              path: '/couponRecharge',
              name: '券充值',
              component: () => import('@/views/customer/couponRecharge'),
              meta: {
                title: '券充值',
              },
            },
            {
              path: '/newRetailTopUp',
              name: '新零售充值',
              component: () => import('@/views/customer/newRetailTopUp'),
              meta: {
                title: '新零售充值',
              },
            },
            {
              path: '/compile',
              name: '客户信息',
              component: resolve => require(['@/views/customer/compile'],resolve),
              // component: resolve=>(require(["@/components/HelloWorld"],resolve))
              meta: {
                title: '客户信息',
              },
            },
            {
              path: '/walletHistory',
              name: '钱包余额明细',
              component: () => import('@/views/customer/walletHistory'),
              meta: {
                title:'钱包余额明细',//moneyHistory,
              },
            },
            {
              path: '/walletHistory',
              name: '进货款明细',
              component: () => import('@/views/customer/walletHistory'),
              meta: {
                title:'进货款明细',//moneyHistory,
              },
            },
            {
              path: '/walletHistory',
              name: '新零售明细',
              component: () => import('@/views/customer/walletHistory'),
              meta: {
                title:'新零售明细',//moneyHistory,
              },
            },
            {
              path: '/bagDetail',
              name: '包包明细',
              component: () => import('@/views/customer/bagDetail'),
              meta: {
                title:'包包明细',
              },
            },{
              path: '/redpacketDetail',
              name: '红包明细',
              component: () => import('@/views/customer/redpacketDetail'),
              meta: {
                title:'红包明细',
              },
            },
            {
              path: '/consumptionHistory',
              name: '消费积分明细',
              component: () => import('@/views/customer/consumptionHistory'),
              meta: {
                title: '消费积分明细',
              },
            },{
              path: '/pickUpGoodsHistory',
              name: '购物券明细',
              component: () => import('@/views/customer/pickUpGoodsHistory'),
              meta: {
                title: '购物券明细',
              },
            },{
              path: '/exchangeHistory',
              name: '兑换券明细',
              component: () => import('@/views/customer/exchangeHistory'),
              meta: {
                title: '兑换券明细',
              },
            },{
              path: '/expendHistory',
              name: '消费金明细',
              component: () => import('@/views/customer/expendHistory'),
              meta: {
                title: '消费金明细',
              },
            },
            {
              path: '/expendRegistrationHistory',
              name: '注册币明细',
              component: () => import('@/views/customer/expendRegistrationHistory'),
              meta: {
                title: '注册币明细',
              },
            },
            {
              path: '/giftVoucherHistory',
              name: '提货券明细',
              component: () => import('@/views/customer/giftVoucherHistory'),
              meta: {
                title: '提货券明细',
              },
            },
            {
              path: '/cashCouponHistory',
              name: '现金券明细',
              component: () => import('@/views/customer/cashCouponHistory'),
              meta: {
                title: '现金券明细',
              },
            },
            {
              path: '/expendAdjust',
              name: '消费金调整',
              component: () => import('@/views/balanceAdjust/expendAdjust'),
              meta: {
                title: '消费金调整',
              },
            },
            {
              path: '/registrationAdjust',
              name: '注册币调整',
              component: () => import('@/views/balanceAdjust/registrationAdjust'),
              meta: {
                title: '注册币调整',
              },
            },
            {
              path: '/giftVoucherAdjust',
              name: '提货券调整',
              component: () => import('@/views/balanceAdjust/giftVoucherAdjust'),
              meta: {
                title: '提货券调整',
              },
            },
            {
              path: '/cashCouponAdjust',
              name: '现金券调整',
              component: () => import('@/views/balanceAdjust/cashCouponAdjust'),
              meta: {
                title: '现金券调整',
              },
            },
            {
              path: '/ConsumerRecords',
              name: '会员升级记录',
              component: () => import('@/views/customer/ConsumerRecords'),
              meta: {
                title: '会员升级记录',
              },
            },
            {
              path: '/TeamInfoList',
              name: '市场关系',
              component: () => import('@/views/customer/TeamInfoList'),
              meta: {
                title: '市场关系',
              },
            },

            {
              path: '/upgradeProcess',
              name: '升级进程',
              component: () => import('@/views/upgradeProcess'),
              meta: {
                title: '升级进程',
              },
            },
            {
              path: '/upgradeProcess',
              name: '星级进程',
              component: () => import('@/views/upgradeProcess'),
              meta: {
                title: '星级进程',
              },
            },
            {
              path: '/upgradeProcess',
              name: '新零售进程',
              component: () => import('@/views/upgradeProcess'),
              meta: {
                title: '新零售进程',
              },
            },
            //  {
            //   path: '/fans',
            //   name: '粉丝列表',
            //   component: () => import('@/views/customer/fans'),
            //   meta: {
            //     title: '粉丝列表',
            //   },
            // },
            {
              path: '/intoAmount',
              name: '会员入账记录',
              component: () => import('@/views/intoAmount'),
              meta: {
                title: '会员入账记录',
              },
            },
            {
              path: '/withdraw',
              name: '提现管理',
              component: () => import('@/views/withdraw'),
              meta: {
                title: '提现管理',
              },
            },  {
              path: '/withdStats',
              name: '提现统计',
              component: () => import('@/views/withdraw/withdStats'),
              meta: {
                title: '提现统计',
              },
            },
            {
              path: '/feedback',
              name: '客户留言',
              component: () => import('@/views/feedback'),
              meta: {
                title: '客户留言',
              },
            },
            {
              path: '/feesList',
              name: '分佣列表',
              component: () => import('@/views/feesList'),
              meta: {
                title: '分佣列表',
              },
            },
            {
              path: '/purseAdjust',
              name: '钱包余额调整',
              component: () => import('@/views/balanceAdjust/purseAdjust'),
              meta: {
                title: '钱包余额调整',
              },
            },
            {
              path: '/paymentAdjust',
              name: '货款余额调整',
              component: () => import('@/views/balanceAdjust/paymentAdjust'),
              meta: {
                title: '货款余额调整',
              },
            },
            {
              path: '/territoryInternational',
              name: '国际区域(地区)控制',
              component: () => import('@/views/territoryInternational/index'),
              meta: {
                title: '国际区域(地区)控制',
              },
            },
            {
              path: '/bagAdjust',
              name: '包包余额调整',
              component: () => import('@/views/balanceAdjust/bagAdjust'),
              meta: {
                title: '包包余额调整',
              },
            },
            {
              path: '/consumptionAdjust',
              name: '消费积分调整',
              component: () => import('@/views/balanceAdjust/consumptionAdjust'),
              meta: {
                title: '消费积分调整',
              },
            },
            {
              path: '/pickUpGoodsAdjust',
              name: '购物券调整',
              component: () => import('@/views/balanceAdjust/pickUpGoodsAdjust'),
              meta: {
                title: '购物券调整',
              },
            },
            {
              path: '/exchangeAdjust',
              name: '兑换券调整',
              component: () => import('@/views/balanceAdjust/exchangeAdjust'),
              meta: {
                title: '兑换券调整',
              },
            },

            {
              path: '/appreciationVoucherAdjust',
              name: '升值券调整',
              component: () => import('@/views/balanceAdjust/appreciationVoucherAdjust'),
              meta: {
                title: '升值券调整',
              },
            },
            {
              path: '/appreciationVoucherHistory',
              name: '升值券明细',
              component: () => import('@/views/customer/appreciationVoucherHistory'),
              meta: {
                title: '升值券明细',
              },
            },
            {
              path: '/distributionCouponHistory',
              name: '流通券明细',
              component: () => import('@/views/customer/distributionCouponHistory'),
              meta: {
                title: '流通券明细',
              },
            },
            {
              path: '/distributionCouponAdjust',
              name: '流通券调整',
              component: () => import('@/views/balanceAdjust/distributionCouponjustAdjust'),
              meta: {
                title: '流通券调整',
              },
            },
            {
              path: '/distributionCouponExchange',
              name: '流通券兑换记录',
              component: () => import('@/views/customer/distributionCouponExchange'),
              meta: {
                title: '流通券兑换记录',
              },
            },
            {
              path: '/yunshiyuPointAdjust',
              name: '微商积分调整',
              component: () => import('@/views/balanceAdjust/yunshiyuPointAdjust'),
              meta: {
                title: '微商积分调整',
              },
            }, {
              path: '/yunshiyuPointHistory',
              name: '微商积分明细',
              component: () => import('@/views/customer/yunshiyuPointHistory'),
              meta: {
                title: '微商积分明细',
              },
            },
            {
              path: '/yunshiyuPerformanceHistory',
              name: '微商业绩明细',
              component: () => import('@/views/customer/yunshiyuPerformanceHistory'),
              meta: {
                title: '微商业绩明细',
              },
            },

            {
              path: '/userAdjust',
              name: '剩余用户调整',
              component: () => import('@/views/balanceAdjust/userAdjust'),
              meta: {
                title: '剩余用户余额调整',
              },
            },{
              path: '/redpacketAdjust',
              name: '剩余红包调整',
              component: () => import('@/views/balanceAdjust/redpacketAdjust'),
              meta: {
                title: '剩余红包余额调整',
              },
            },
            {
              path: '/storeList',
              name: '领取点',
              component: () => import('@/views/customer/storeList'),
              meta: {
                title: '领取点列表',
              }
            },
            {
              path: '/region',
              redirect: '/regionAgency',
              name: '地区代理',
              component: () => import('@/views/regionAgency'),
              meta: {
                title: '地区代理',
              },
              children: [
                {
                  path: '/regionAgency',
                  name: '地区',
                  component: () => import('@/views/regionAgency/region'),
                  meta: {
                    title: '地区',
                  },
                },
              ]
            },
            {
              path: '/rankingList',
              redirect: '/ranking',
              name: '业绩Top30排行榜',
              component: () => import('@/views/rankingList'),
              meta: {
                title: '业绩Top30排行榜',
              },
              children: [
                {
                  path: '/ranking',
                  name: 'Top30排行榜',
                  component: () => import('@/views/rankingList/ranking'),
                  meta: {
                    title: 'Top30排行榜',
                  },
                },
              ]
            },
            {
              path: '/general',
              redirect: '/generalList',
              name: '108将',
              component: () => import('@/views/general'),
              meta: {
                title: '108将业绩',
              },
              children: [
                {
                  path: '/generalList',
                  name: '108将业绩',
                  component: () => import('@/views/general/generalList'),
                  meta: {
                    title: '108将业绩',
                  },
                },
              ]
            },
            {
              path: '/cavalry',
              redirect: '/cavalryList',
              name: '8000铁骑',
              component: () => import('@/views/cavalry'),
              meta: {
                title: '8000铁骑业绩',
              },
              children: [
                {
                  path: '/cavalryList',
                  name: '8000铁骑业绩',
                  component: () => import('@/views/cavalry/cavalryList'),
                  meta: {
                    title: '8000铁骑业绩',
                  },
                },
              ]
            },
            {
              path: '/newRetailpPerformanceList',
              name: '新零售直推业绩',
              component: () => import('@/views/newRetailpPerformance'),
              meta: {
                title: '列表',
              },
            },
             {
              path: '/feesStats',
              name: '统计',
              component: () => import('@/views/feesList/feesStats'),
              meta: {
                title: '统计',
              },
            },
            {
              path: '/direct',
              name: '直推业绩',
              component: () => import('@/views/performance/team'),
              meta: {
                title: '直推业绩',
              },
            },
            {
              path: '/team',
              name: '团队业绩',
              component: () => import('@/views/performance/team'),
              meta: {
                title: '团队业绩',
              },
            },
            {
              path: '/yjgPerformance',
              name: '云吉购业绩',
              component: () => import('@/views/yjgPerformance/yjgPerformance'),
              meta: {
                title: '云吉购业绩',
              },
            },{
              path: '/yjgCountryPerformance',
              name: '国家业绩',
              component: () => import('@/views/yjgPerformance/yjgCountryPerformance'),
              meta: {
                title: '国家业绩',
              },
            },
            {
              path: '/yjgPortion',
              name: '云吉购份额',
              component: () => import('@/views/yjgPerformance/yjgPortion'),
              meta: {
                title: '云吉购份额',
              },
            },
            {
              path: '/yjgPerformanceShare',
              name: '云吉购直推和个人业绩',
              component: () => import('@/views/yjgPerformance/yjgPerformanceShare'),
              meta: {
                title: '云吉购直推业绩',
              },
            },
            {
              path: '/yjgPerformanceTeam',
              name: '云吉购团队业绩',
              component: () => import('@/views/yjgPerformance/yjgPerformanceTeam'),
              meta: {
                title: '云吉购团队业绩',
              },
            },
            {
              path: '/yjgPerformanceTeamMax',
              name: '云吉购团队业绩',
              component: () => import('@/views/yjgPerformance/yjgPerformanceTeamMax'),
              meta: {
                title: '云吉购团队业绩',
              },
            },
            {
              path: '/yjgPerformanceTeamMin',
              name: '云吉购小市场业绩',
              component: () => import('@/views/yjgPerformance/yjgPerformanceTeamMin'),
              meta: {
                title: '云吉购小市场业绩',
              },
            },
            {
              path: '/customerRelationship',
              name: '关系链条',
              component: () => import('@/views/customer/customerRelationship'),
              meta: {
                title: '关系链条',
              },
            },
            {
              path: '/customerRelationshipTree',
              name: '粉丝链条',
              component: () => import('@/views/customer/customerRelationshipTree'),
              meta: {
                title: '粉丝链条',
              },
            },


            // {
            //   path: '/team',
            //   name: '直推业绩',
            //   component: () => import('@/views/performance/team'),
            //   meta: {
            //     title: '直推业绩',
            //   },
            // },
            // /admin/store/list

          ]
        },
        //订单
        {
          path: '/order',
          redirect: '/ordersCommodity',
          name: '订单',
          component: () => import('@/views/order'),
          meta: {
            title: '订单',
          },
          children: [
            {
              path: '/ordersCommodity',
              name: '商品订单管理',
              component: () => import('@/views/orderInfo'),
              meta: {
                title: '商品订单管理',
              },
            },
            {
              path: '/foreinorderInfo',
              name: '海外商品订单',
              component: () => import('@/views/foreinorderInfo'),
              meta: {
                title: '海外商品订单',
              },
            },
            {
              path: '/ordersRecharge',
              name: '充值订单管理',
              component: () => import('@/views/ordersRecharge'),
              meta: {
                title: '充值订单管理',
              },
            },
            {
              path: '/newBagTopUp',
              name: '新包充值订单管理',
              component: () => import('@/views/newBagTopUp'),
              meta: {
                title: '新包充值订单管理',
              },
            },

            {
              path: '/otherInfo',
              name: '第三方平台订单管理',
              component: () => import('@/views/otherInfo/index'),
              meta: {
                title: '第三方平台订单管理',
              },
            },
            {
              path: '/mobileInfo',
              name: '手机充值订单管理',
              component: () => import('@/views/mobileInfo/index'),
              meta: {
                title: '手机充值订单管理',
              },
            }, {
              path: '/yjRechargeOrder',
              name: '云吉充值订单',
              component: () => import('@/views/yjRechargeOrder/index'),
              meta: {
                title: '云吉充值订单',
              },
            },
            {
              path: '/foreinRecharOrder',
              name: '海外充值订单',
              component: () => import('@/views/yjRechargeOrder/foreinRecharOrder'),
              meta: {
                title: '海外充值订单',
              },
            }, 
            {
              path: '/couponRechargeOrder',
              name: '券充值单',
              component: () => import('@/views/yjRechargeOrder/couponRechargeOrder'),
              meta: {
                title: '券充值单',
              },
            },

            {
              path: '/aBonus',
              name: '分红',
              component: () => import('@/views/aBonus/index'),
              meta: {
                title: '分红',
              },
            },
            {
              path: '/aBonusList',
              name: '分红列表',
              component: () => import('@/views/aBonusList/index'),
              meta: {
                title: '分红列表',
              },
            },
            {
              path: '/management',
              name: '董事补贴',
              component: () => import('@/views/management/index'),
              meta: {
                title: '董事补贴',
              },
            },
            {
              path: '/topSacle',
              name: '销冠奖',
              component: () => import('@/views/topSacle/topSacle'),
              meta: {
                title: '销冠奖',
              },
            },
            {
              path: '/topSacleSelf',
              name: '手动分销冠奖',
              component: () => import('@/views/topSacle/index'),
              meta: {
                title: '手动分销冠奖',
              },
            },
            {
              path: '/managementList',
              name: '董事补贴列表',
              component: () => import('@/views/management/managementList'),
              meta: {
                title: '董事补贴列表',
              },
            },
            {
              path: '/ForeignPool',
              name: '国外现金分红',
              component: () => import('@/views/ForeignPool/index'),
              meta: {
                title: '国外现金分红',
              },
            },
            {
              path: '/foreignPoolList',
              name: '国外现金分红列表',
              component: () => import('@/views/ForeignPool/foreignPoolList'),
              meta: {
                title: '国外现金分红列表',
              },
            },
            {
              path: '/cnBonusPool',
              name: '国内分红',
              component: () => import('@/views/cnBonusPool/index'),
              meta: {
                title: '国内分红',
              },
            },
            {
              path: '/poolList',
              name: '国内分红列表',
              component: () => import('@/views/cnBonusPool/poolList'),
              meta: {
                title: '国内分红列表',
              },
            },
            {
              path: '/applyOrder',
              name: '微商订单',
              component: () => import('@/views/applyOrder'),
              meta: {
                title: '微商订单',
              },
            },
            {
              path: '/ordersRefund',
              name: '服务单管理',
              component: () => import('@/views/orderRefund'),
              meta: {
                title: '服务单管理',
              },
            },
            {
              path: '/isForeignorderRefund',
              name: '海外退款订单',
              component: () => import('@/views/isForeignorderRefund'),
              meta: {
                title: '海外退款订单',
              },
            },
            {
              path: '/retailTopup',
              name: '新零售充值订单管理',
              component: () => import('@/views/retailTopup'),
              meta: {
                title: '新零售充值订单管理',
              },
            },

            {
              path: '/giftBag',
              redirect: '/giftBagList',
              name: '新零售',
              component: () => import('@/views/giftBag'),
              meta: {
                title: '新零售',
              },
              children: [
                {
                  path: '/giftBagList',
                  name: '新零售列表',
                  component: () => import('@/views/giftBag/giftBagList'),
                  meta: {
                    title: '新零售列表',
                  },
                },
              ]
            },

          ]
        },
        // 系统
        {
          path: '/systemmanage',
          redirect: '/user',
          name: '系统管理',
          component: () => import('@/views/usermanage'),
          meta: {
            title: '系统管理',
          },
          children: [
            {
              path: '/user',
              name: '用户管理',
              component: () => import('@/views/usermanage/user'),
              meta: {
                title: '用户管理',
              },
            }, {
              path: '/roleManage',
              name: '角色管理',
              component: () => import('@/views/usermanage/roleManage'),
              meta: {
                title: '角色管理',
              },
            },
            //  {
            //   path: '/departmentManage',
            //   name: '部门管理',
            //   component: () => import('@/views/usermanage/departmentManage'),
            //   meta: {
            //     title: '部门管理',
            //   },
            // },
            {
              path: '/menuManage',
              name: '菜单管理',
              component: () => import('@/views/usermanage/menuManage'),
              meta: {
                title: '菜单管理',
              },
            },
            {
              path: '/Versioning',
              name: 'App版本管理',
              component: () => import('@/views/usermanage/Versioning'),
              meta: {
                title: 'App版本管理',
              },
            },

          ]
        },
        // 素材
        {
          path: '/material',
          redirect: '/publicity',
          name: '素材',
          component: () => import('@/views/material'),
          meta: {
            title: '素材',
          },
          children: [
            {
              path: '/market',
              name: '商学院',
              component: () => import('@/views/material/market'),
              meta: {
                title: '商学院',
              },
            },
            {
              path: '/publicity',
              name: '宣传素材',
              component: () => import('@/views/material/publicity'),
              meta: {
                title: '宣传素材',
              },
            },
            {
              path: '/seeding',
              name: '种草',
              component: () => import('@/views/seeding/index'),
              meta: {
                title: '种草',
              },
            },

          ]
        },
        // 优惠券
        {
          path: '/material',
          redirect: '/discountCoupon',
          name: '优惠券',
          component: () => import('@/views/discountCoupon/'),
          meta: {
            title: '优惠券',
          },
          children: [
            {
              path: '/discountCoupon',
              name: '优惠券管理',
              component: () => import('@/views/discountCoupon/discountCoupon'),
              meta: {
                title: '优惠券管理 ',
              },
            },
          ]
        },
        // 图形统计
        {
          path: '/graph',
          redirect: '/MarketChart',
          name: '图形统计',
          component: () => import('@/views/graph/'),
          meta: {
            title: '图形统计',
          },
          children: [
            {
              path: '/MarketChart',
              name: '销售图表',
              component: () => import('@/views/graph/MarketChart'),
              meta: {
                title: '销售图表 ',
              },
            },
            {
              path: '/payTimeStats',
              name: '支付时间统计',
              component: () => import('@/views/payTimeStats'),
              meta: {
                title: '支付时间统计 ',
              },
            },
            {
              path: '/otherTotal',
              name: '第三方统计',
              component: () => import('@/views/otherTotal'),
              meta: {
                title: '统计 ',
              },
            },

          ],
        },
        // 后台更新
        {
          path: '/uploadFile',
          redirect: '/upload',
          name: '后台更新',
          component: () => import('@/views/uploadFile/'),
          meta: {
            title: '后台更新',
          },
          children: [
            {
              path: '/uploadFile',
              name: '后台上传',
              component: () => import('@/views/uploadFile/uploadFile'),
              meta: {
                title: '后台上传 ',
              },
            },
          ]
        },
        {
          path:'/signInEdit',
          // redirect: '/signInEdit',
          name:'签到管理',
          component:()=>import('@/views/signIn/index'),
          meta:{
            title:'签到管理',
          },
          children:[
            {
              path:'/signInEdit',
              name:'',
              component:()=>import('@/views/signIn/signInEdit'),
              meta:{
                title:'签到编辑'
              }
            },
            {
              path:'/giftOrder',
              name:'',
              component:()=>import('@/views/signIn/giftOrder'),
              meta:{
                title:'礼品订单列表'
              }
            }
          ],
        },
        // 直播管理
        {
          path:'/liveMessageRecord',
          // redirect: '/signInEdit',
          name:'直播管理',
          component:()=>import('@/views/liveManage/index'),
          meta:{
            title:'直播管理',
          },
          children:[
            {
              path:'/liveMessageRecord',
              name:'直播间信息表',
              component:()=>import('@/views/liveManage/liveMessageRecord'),
              meta:{
                title:'直播间信息表'
              }
            },
            {
              path:'/liveRoomDetail',
              name:'直播详情表',
              component:()=>import('@/views/liveManage/liveRoomDetail'),
              meta:{
                title:'直播详情表'
              }
            },
            {
              path:'/liveRoom',
              name:'直播记录表',
              component:()=>import('@/views/liveManage/liveRoom'),
              meta:{
                title:'直播记录表'
              }
            },
            {
              path:'/video',
              name:'短视频',
              component:()=>import('@/views/liveManage/video'),
              meta:{
                title:'短视频'
              }
            },
            {
              path:'/videoList',
              name:'短视频列表',
              component:()=>import('@/views/liveManage/videoList'),
              meta:{
                title:'短视频列表'
              }
            },
            {
              path:'/test',
              name:'test',
              component:()=>import('@/views/test/index'),
              meta:{
                title:'test'
              }
            }

          ],
        }
      ]
    },
  ]
})

router.beforeEach((to, from, next) => {
  // console.log(to,from,'to,from');
  // console.log(next,'next');

  if (localStorage.getItem('aljsToken') && localStorage.getItem('aljsToken') != '') {
    let routeUrl=JSON.parse(localStorage.getItem('routeUrl'))
    // let routePath=localStorage.getItem('routePath')
    let path=""
    let routePath=""
    if (from.path!='/login') {
      if (routeUrl) {
        routePath = routeUrl[0].list[0].url
        routeUrl.map(val=>{

          if (val.list) {
            val.list.map(_val=>{

              if (!path&&to.path==_val.url) {
                path=_val.url
              }
              if (_val.list) {
                _val.list.map(_val_=>{
                  if (!path&&to.path==_val_.url) {
                    path=_val_.url
                  }
                })
              }
            })
          }
        })
        if (path) {
          next()
        }else if (routePath!=to.path) {
          next({path:routePath})
        }else{
         next()
        }
      }else{
       next()
      }
    }else{
      next()
    }
  } else {
    localStorage.clear()
    sessionStorage.clear()
    let keys = document.cookie.match(/[^=;]+(?=\=)/g)
    if (keys) {
      for (let i = keys.length; i--;) {
        document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
      }
    }
    if (to.path.indexOf('login') != -1) {
      next()
    } else {
      Message({
        message: '登录信息已过期，请重新登录！',
        type: 'warning'
      })
      next({ path: '/login' })
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js